export enum ButtonType {
  DEFAULT = "default",
  PRIMARY = "primary",
  LINK = "link",
  TEXT = "text",
  GHOST = "ghost",
  DELETE = "delete",
  DASHED = "dashed",
}

export enum ButtonSize {
  LARGE = "large",
  MEDIUM = "middle",
  SMALL = "small",
}

export enum ButtonHTMLType {
  SUBMIT = "submit",
  BUTTON = "button",
}

export enum ButtonShape {
  DEFAULT = "default",
  ROUND = "round",
  CIRCLE = "circle",
}

export enum CommonButtonTexts {
  CANCEL = "Cancel",
  CONFIRM = "Confirm",
  NEXT = "Next",
  PREVIOUS = "Previous",
  SAVE = "Save",
  SUBMIT = "Submit",
  APPROVE = "Approve",
  CREATE = "Create",
  EDIT = "Edit",
  DOWNLOAD = "Download",
  CLEAR_FILTERS = "Clear Filters",
  APPLY = "Apply",
  EXIT = "Exit",
}
